import React from 'react';
import { Query } from '@apollo/client/react/components';
import cx from 'classnames';
import { faCcStripe } from '@fortawesome/free-brands-svg-icons/faCcStripe';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import numeral from 'numeral';

import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const BillingHistory = require('buyside/graphql/queries/BillingHistory.graphql');

import {
  BillingHistoryQueryVariables,
  BillingHistoryQuery,
  Maybe
} from 'interfaces/graphql-typings';

import { formatDate } from 'buyside/components/presentation/UserAccount/BillingInformation/util';

import styles from './billingHistoryStyles.scss';

const BillingHistoryContainer: React.FC = (): React.ReactElement => (
  <Query<BillingHistoryQuery, BillingHistoryQueryVariables> query={BillingHistory}>
    {({ loading, data, error }): Maybe<React.ReactElement> => {
      if (error) throw error;
      if (loading || !data) return <LoadingSpinner size={SIZES.TINY} />;
      if (!data.currentUser) return null;

      const { billingHistory } = data.currentUser;

      return billingHistory?.length === 0 || !data.currentUser.stripeCustomerId ? (
        <div>No subscription billing history.</div>
      ) : (
        <table className={styles['billing-history-table']}>
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Amount</th>
              <th scope="col">Description</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {billingHistory?.map(
              (history): Maybe<React.ReactElement> => {
                if (!history) return null;

                const { paidDate, amount, description, status } = history;
                const { day, month, year } = paidDate;

                return (
                  <tr key={`${day}-${amount}-${status}`}>
                    <td>{formatDate({ day, month, year })}</td>
                    <td>{numeral(amount).format('$0,0')}</td>
                    <td>{description}</td>
                    <td className={cx(styles[status])}>
                      <FontAwesomeIcon
                        icon={faCcStripe}
                        size="2x"
                        className={cx(styles['stripe-icon'])}
                      />{' '}
                      {status}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      );
    }}
  </Query>
);

export default BillingHistoryContainer;
